export const routes = (prefix) => [
    {
        path: `/${prefix}/register-cover`,
        name: `${prefix}.register-cover.index`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.register-cover.index`,
                PageDescription: "Register Cover",
            },
        },
    },
];
